import React from 'react';
import './App.css';   
import {
  Route,
  Routes,
  BrowserRouter,
  useParams
} from "react-router-dom";

// NavBar and Footer 
import NavBar from './components/NavBar';
import Footer from './components/Footer';

// Socket button
import SocketButton from './components/SocketButton';

// screens
import HomeScreen from './screens/HomeScreen';
import LoginScreen from './screens/LoginScreen';
import ProductsScreen from './screens/ProductsScreen';
import CartScreen from './screens/CartScreen';
import OrdersScreen from './screens/OrdersScreen';
import SignUp from './screens/SignUpScreen';
import DataScreen from './screens/ProductSalesData';
import ForgotPasswordScreen from './screens/ForgotPwdScreen';
import ResetPasswordScreen from './screens/ResetPassword';
import ProductDetailsScreen from './screens/ProductDetailsScreen';
import CategoryScreen from './screens/CategoryScreen';
import ReviewsScreen from './screens/ReviewsScreen';
import RatingFilterScreen from './screens/FilterRatingScreen';
import ProfileScreen from './screens/ProfileScreen';
import UnauthorizedScreen from './screens/UnauthorizedScreen';
import AdminScreen from './screens/adminScreen';
import AddressDetailsScreen from './screens/AddressDetailsScreen';
import PaymentScreen from './screens/PaymentScreen';
import JoinRoom from './screens/JoinRoom';
// added orders and orderDetails and solved merge conflict
import OrderDetails from './screens/OrderDetails';
import CartDetailsScreen from './screens/CartDetailsScreen';
import AddProductScreen from './screens/AddProductScreen';
import AddCategoryScreen from './screens/AddCategoryScreen';
import MemoryGameScreen from './screens/MemoryGameScreen';
import UpdatePdtScreen from './screens/UpdatePdtScreen';
import AddReviewsScreen from './screens/AddReviewsScreen';
import NoDataScreen from './screens/NoDataScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import NoReviewsFilterScreen from './screens/NoReviewsFilterScreen';

const ResetPwdWrapper = () => {
  const { id, token } = useParams();
  return <ResetPasswordScreen id={id} token={token} />;
}

const ProductIdWrapper = () => {
  const { productId } = useParams();
  return <ProductDetailsScreen productid={productId} />;
};

const CategoryIdWrapper = () => {
  const { categoryId } = useParams();
  return <CategoryScreen categoryid={categoryId} />;
};

const ReviewIdWrapper = () => {
  const { productid } = useParams();
  return <ReviewsScreen productid={productid}/>
}

const DataScreenWrapper = () => {
  const { productid } = useParams();
  return <DataScreen productid={productid}/>
}

const ProfileScreenWrapper = () => {
  const { userid } = useParams();
  return <ProfileScreen userid={userid} /> 
}

const CartsScreenWrapper = () => {
  const { userid } = useParams();
  return <CartScreen userid={userid} /> 
}

const AddressIdWrapper = () => {
  const { userid, cartid } = useParams();
  return <AddressDetailsScreen userid={userid} cartid={cartid} /> 
}

const MemoryUserWrapper = () => {
  const { userid } = useParams();
  return <MemoryGameScreen userid={userid} /> 
}

const PaymentIdWrapper = () => {
  const { userid, cartid } = useParams();
  return <PaymentScreen userid={userid} cartid={cartid} /> 
}

const UpdatePdtIdWrapper = () => {
  const { productId } = useParams();
  return <UpdatePdtScreen productid={productId} />;
};

const AddReviewWrapper = () => {
  const { userid, productid } = useParams();
  return <AddReviewsScreen userid={userid} productid={productid}/>
}

function App() {
  return (
    <div>
      <NavBar />
        <BrowserRouter>
          <Routes>
            <Route exact path='/' element={<HomeScreen />}/>
            <Route path='/login' element={<LoginScreen />}/>
            <Route path='/sign-up' element={<SignUp />} />
            <Route path='/forgot-password' element={<ForgotPasswordScreen />}/>
            <Route path='/reset-password/:id/:token' element={<ResetPwdWrapper />} />
            <Route path='/user/:userid/profile' element={<ProfileScreenWrapper />} />
            <Route path='/unauthorized' element={<UnauthorizedScreen />}/>
            <Route path='/no-sales-data' element={<NoDataScreen />}/>
            <Route path='/products' element={<ProductsScreen />}/>
            <Route path='/products/:productid' element={<ProductIdWrapper />}/>
            <Route path='/category/:categoryid/products' element={<CategoryIdWrapper />}/>
            <Route path='/user/:userid/carts' element={<CartsScreenWrapper />}/>
            <Route path='/users/:userid/cart/:cartid' element={<CartDetailsScreen />}/>
            <Route path='/users/:userid/cart/:cartid/address-details' element={<AddressIdWrapper />}/>
            <Route path='/users/:userid/cart/:cartid/payment' element={<PaymentIdWrapper />}/>
            <Route path='/product/:productid/reviews' element={<ReviewIdWrapper/>}/>
            <Route path='/product/:productid/rating-search' element={<RatingFilterScreen />} />
            <Route path='/orders' element={<OrdersScreen />}/>
            <Route path='/order-details/users/:userid/orders/:orderid' element={<OrderDetails />}/>
            <Route path='/join-room' element={<JoinRoom />}/>
            <Route path='/cart' element={<CartScreen />}/>
            <Route path='/data-visuals/product/:productid' element={<DataScreenWrapper />}/>
            <Route path='/admin' element={<AdminScreen />}/>
            <Route path='/admin/add-product' element={<AddProductScreen/>} />
            <Route path='/admin/add-category' element={<AddCategoryScreen />}/>
            <Route path='/user/:userid/game' element={<MemoryUserWrapper />} />
            <Route path='/products/:productid/update-product' element={<UpdatePdtIdWrapper />}/>
            <Route path='/user/:userid/product/:productid/add-review' element={<AddReviewWrapper/>} />
            <Route path='/no-review-filter' element={<NoReviewsFilterScreen/>}/>
            <Route path='*' element={<NotFoundScreen />} />
          </Routes>
        </BrowserRouter>
      <Footer />
      <SocketButton />
    </div>
  );
}

export default App;
